export default function* () {
    // Paginated datasets are handled by composeDatasetsSaga
}
